const d = {
  fireDangerDirective: {
    url:
      "https://sapowernetworks.sharepoint.com/sites/QMS/Controlled Documents Library/Catastrophic and Extreme Fire Danger Directive.pdf#search=Bushfire",
    title: "Catastrophic and Extreme Fire Danger Directive"
  },
  bioSecurity: {
    url:
      "https://sapowernetworks.sharepoint.com/:w:/r/sites/QMS/_layouts/15/Doc.aspx?sourcedoc=%7B9CC67002-10B5-4813-B393-B55BB5E3A231%7D&file=EMS%205.2%20Biosecurity%20-%20Pest%20Plant%20Animal%20Disease%20Management.docx&action=default&mobileredirect=true&DefaultItemOpen=1&cid=2f872802-cdeb-48dc-a1ec-f05b01a2c981",
    title: "Bio-Security"
  },
  generalWeeds: {
    url:
      "https://sapowernetworks.sharepoint.com/:w:/r/sites/QMS/_layouts/15/Doc.aspx?sourcedoc=%7BE3750354-1DFA-4A26-98E8-4FFE6C8CE276%7D&file=EMS%205.2.1-WI-Weed%20Spread%20Prevention.docx&action=default&mobileredirect=true&DefaultItemOpen=1&cid=0642c0e4-dbb9-44ce-addc-1d5f88c4ebd9",
    title: "General Weeds"
  },
  phytophtora: {
    url:
      "https://sapowernetworks.sharepoint.com/:w:/r/sites/QMS/_layouts/15/Doc.aspx?sourcedoc=%7BFC132D1E-C57C-4F2C-8C6D-D72E3C0E0480%7D&file=EMS%205.2.2-WI-Phytophthora%20Spread%20Prevention.docx&action=default&mobileredirect=true&DefaultItemOpen=1&cid=452ae9ae-e53a-409b-8744-4f55bcee8dc3",
    title: "Phytophtora"
  },
  floraAndFauna: {
    url:
      "https://sapowernetworks.sharepoint.com/:w:/r/sites/QMS/_layouts/15/Doc.aspx?sourcedoc=%7B940E0FBF-8073-4EB3-8910-16E0A7BC92CD%7D&file=EMS%205.5%20Flora%20and%20Fauna%20Management%20Procedure.docx&action=default&mobileredirect=true&DefaultItemOpen=1&cid=e110d73d-60b4-4786-962a-3815aab69e06",
    title: "Flora & Fauna"
  },
  significantRoadsideVeg: {
    url:
      "https://sapowernetworks.sharepoint.com/sites/QMS/_layouts/15/AccessDenied.aspx?Source=https%3A%2F%2Fsapowernetworks%2Esharepoint%2Ecom%2Fsites%2FQMS%2F%5Flayouts%2F15%2FDoc%2Easpx%3Fsourcedoc%3D%257B71DBA02E%2DE62E%2D4830%2D86DE%2DA613431D1A7C%257D%26file%3DEMS%2520Significant%2520Roadside%2520Vegetation%2Edocx%26action%3Ddefault%26mobileredirect%3Dtrue%26DefaultItemOpen%3D1&correlation=e46d839f%2Dd088%2D0000%2D489b%2D946eb4608d0c&Type=item&name=80349afd%2D6890%2D45e1%2Dac76%2D2aee93ed70ef&listItemId=2805",
    title: "Significant Roadside Vegetation"
  }
};
export const directives = {
  "Contaminated Site": [d.bioSecurity],
  "Conservation Reserve AMLR": [d.bioSecurity, d.floraAndFauna],
  "Conservation Reserve SAMDB": [d.bioSecurity, d.floraAndFauna],
  "Significant Roadside Vegetation": [d.significantRoadsideVeg],
  Phytophthora: [d.phytophtora],
  "Declared Weed Zone": [d.bioSecurity, d.generalWeeds],
  "CFS Fire Ban District": [d.fireDangerDirective]
};

export const startingLocations = [
  {
    label: "Angaston Depot",
    abbr: "angaston",
    location: [-34.506802, 139.024694]
  },
  {
    label: "Angle Park (Training) Depot",
    abbr: "angletraining",
    location: [-34.850095, 138.558814]
  },
  {
    label: "Angle Park North Depot",
    abbr: "anglenorth",
    location: [-34.850003, 138.561164]
  },
  {
    label: "Angle Park South Depot",
    abbr: "anglesouth",
    location: [-34.854616, 138.564715]
  },
  {
    label: "Barmera Depot",
    abbr: "barmera",
    location: [-34.255744, 140.462489]
  },
  {
    label: "Bordertown Depot",
    abbr: "bordertown",
    location: [-36.313433, 140.779443]
  },
  {
    label: "Ceduna Depot",
    abbr: "ceduna",
    location: [-32.119655, 133.68148]
  },
  {
    label: "Clare Depot",
    abbr: "clare",
    location: [-33.834518, 138.616057]
  },
  {
    label: "Cleve Depot",
    abbr: "cleve",
    location: [-33.702466, 136.483201]
  },
  {
    label: "Davenport Depot",
    abbr: "davenport",
    location: [-32.477601, 137.781484]
  },
  {
    label: "Elizabeth Depot",
    abbr: "elizabeth",
    location: [-34.711987, 138.669472]
  },
  {
    label: "Geelong Depot",
    abbr: "geelong",
    location: [-38.106025, 144.341238]
  },
  {
    label: "Hindmarsh Depot",
    abbr: "hindmarsh",
    location: [-34.906285, 138.574994]
  },
  {
    label: "Holden Hill Depot",
    abbr: "holdenhill",
    location: [-34.848005, 138.673708]
  },
  {
    label: "Kadina Depot",
    abbr: "kadina",
    location: [-33.970147, 137.710069]
  },
  {
    label: "Keswick Depot",
    abbr: "keswick",
    location: [-34.942454, 138.581877]
  },
  {
    label: "Kingscote Depot",
    abbr: "kingscote",
    location: [-35.652801, 137.634955]
  },
  {
    label: "Kurralta Park (Museum) Depot",
    abbr: "kurralta",
    location: [-34.948355, 138.564549]
  },
  {
    label: "Marleston North Depot",
    abbr: "marlestonnorth",
    location: [-34.944066, 138.561787]
  },
  {
    label: "Marleston South Depot",
    abbr: "marlestonsouth",
    location: [-34.94713, 138.561496]
  },
  {
    label: "Morphett Vale Depot",
    abbr: "morphettvale",
    location: [-35.105244, 138.534373]
  },
  {
    label: "Mount Barker Depot",
    abbr: "mtbarker",
    location: [-35.07377, 138.864551]
  },
  {
    label: "Mount Gambier Depot",
    abbr: "mtgambier",
    location: [-37.820391, 140.74729]
  },
  {
    label: "Murray Bridge Depot",
    abbr: "murraybridge",
    location: [-35.117673, 139.257013]
  },
  {
    label: "Naracoorte Depot",
    abbr: "naracoorte",
    location: [-36.974634, 140.746537]
  },
  {
    label: "Nuriootpa Depot",
    abbr: "nuriootpa",
    location: [-34.465184, 138.997008]
  },
  {
    label: "Port Augusta Depot",
    abbr: "portaugusta",
    location: [-32.491746, 137.760812]
  },
  {
    label: "Port Lincoln Depot",
    abbr: "portlincoln",
    location: [-34.734949, 135.856938]
  },
  {
    label: "Port Pirie Depot",
    abbr: "portpirie",
    location: [-33.18346, 138.026131]
  },
  {
    label: "Network Innovation Centre",
    abbr: "nic",
    location: [-34.942425, 138.558952]
  },
  {
    label: "Roxby Downs Depot",
    abbr: "roxbydowns",
    location: [-30.487243, 136.886295]
  },
  {
    label: "St Marys Depot",
    abbr: "stmarys",
    location: [-35.010247, 138.580176]
  },
  {
    label: "Streaky Bay Depot",
    abbr: "streakybay",
    location: [-32.796955, 134.221996]
  },
  {
    label: "Victor Harbor Depot",
    abbr: "victorharbor",
    location: [-35.531286, 138.646724]
  },
  {
    label: "Whyalla Depot",
    abbr: "whyalla",
    location: [-33.023613, 137.528089]
  },
  {
    label: "Wingfield Depot",
    abbr: "wingfield",
    location: [-34.842538, 138.568082]
  },
  {
    label: "Wudinna Depot",
    abbr: "wudinna",
    location: [-33.047652, 135.461742]
  },
  {
    label: "Yorketown Depot",
    abbr: "yorketown",
    location: [-35.018523, 137.595391]
  }
];
